import API_BASE_URL from './config';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Signup({ setPlayerId, setUsername, setRole }) {
  const [email, setEmail] = useState('');
  const [username, setLocalUsername] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch(`${API_BASE_URL}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, username, password, inviteCode }),
      });
      const text = await response.text(); // Debug raw response
      console.log('Raw response:', text);
      if (!response.ok) {
        let errorData;
        try {
          errorData = JSON.parse(text);
        } catch (parseErr) {
          throw new Error('Server returned invalid JSON: ' + text);
        }
        throw new Error(errorData.message || 'Signup failed');
      }
      const data = JSON.parse(text);
      localStorage.setItem('playerId', data.playerId);
      localStorage.setItem('username', data.username);
      localStorage.setItem('role', 'Player');
      setPlayerId(data.playerId);
      setUsername(data.username);
      setRole('Player');
      navigate('/my-dogs');
    } catch (err) {
      setError(err.message);
      console.error('Signup error:', err);
    }
  };

  const formStyle = {
    width: '100%',
    maxWidth: '500px',
    margin: '100px auto 20px',
    padding: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '10px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    border: '2px solid #1E88E5',
    boxSizing: 'border-box',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: '1px solid #1E88E5',
    borderRadius: '5px',
    fontSize: '1em',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    backgroundColor: '#1E88E5',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
  };

  const errorStyle = {
    color: 'red',
    margin: '10px 0',
    fontSize: '0.9em',
    textAlign: 'center',
  };

  return (
    <div style={formStyle}>
      <h2 style={{ color: '#1E88E5', textAlign: 'center' }}>Sign Up</h2>
      {error && <p style={errorStyle}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
          required
        />
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setLocalUsername(e.target.value)}
          style={inputStyle}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
          required
        />
        <input
          type="text"
          placeholder="Invite Code"
          value={inviteCode}
          onChange={(e) => setInviteCode(e.target.value)}
          style={inputStyle}
          required
        />
        <button
          type="submit"
          style={buttonStyle}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#1976D2')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#1E88E5')}
        >
          Sign Up
        </button>
      </form>
    </div>
  );
}

export default Signup;